<template>
  <div id="app">
    <ToastProvider>
      <ThemeProvider>
        <RouterView />
      </ThemeProvider>
    </ToastProvider>
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import ThemeProvider from "@/components/shared/Theme/ThemeProvider.vue";
import {onBeforeMount} from "vue";

onBeforeMount(() => {
  // Get saved theme preference
  const savedTheme = localStorage.getItem('theme-preference');

  // Apply theme class immediately if available, otherwise default to light
  if (savedTheme === 'dark') {
    document.documentElement.classList.add('dark');
    document.documentElement.classList.remove('light');
  } else {
    // Default to light theme (covers both 'light' and null cases)
    document.documentElement.classList.add('light');
    document.documentElement.classList.remove('dark');

    // Save light as default if no preference exists
    if (!savedTheme) {
      localStorage.setItem('theme-preference', 'light');
    }
  }
});
</script>